function initAuthForm(){
  const $form   = $('.js-auth-form'),
        $submit = $form.find('.js-submit');

  if (!$form.length) return;

  function toggleSubmit(){
    let allFilled = true;
    // required属性のある input を全部チェック
    $form.find('input[required]').each(function(){
      if (!$(this).val().trim()) {
        allFilled = false;
        return false;
      }
    });
    console.log('allFilled?', allFilled);
    $submit.prop('disabled', !allFilled);
  }

  $form.off('input change', 'input[required]', toggleSubmit)
       .on('input change', 'input[required]', toggleSubmit);

  // 初回チェック
  toggleSubmit();
}

document.addEventListener('DOMContentLoaded', initAuthForm);
document.addEventListener('turbolinks:load', initAuthForm);
document.addEventListener('turbo:load', initAuthForm);